export function detectBreakpoint() {
    let breakpointNames = ["xxl", "xl", "lg", "md", "sm", "xs"];
    let breakpointValues = [];
    const isPriorBS5 = !!window.getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-sm');
    const prefix = isPriorBS5 ? "--breakpoint-" : "--bs-breakpoint-";
    for (const breakpointName of breakpointNames) {
        const value = window.getComputedStyle(document.documentElement).getPropertyValue(prefix + breakpointName);
        if(value) {
            breakpointValues[breakpointName] = value;
        }
    }
    let i = breakpointNames.length;
    for (const breakpointName of breakpointNames) {
        i--
        if (window.matchMedia("(min-width: " + breakpointValues[breakpointName] + ")").matches) {
            return breakpointName;
        }
    }
    return null;
}